export const SET = 'SET';
export const FETCH = 'FETCH';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const SET_USER = 'SET_USER'
export const SET_ALERT = 'SET_ALERT'
